var $a0b9c834fca6fde8$exports = {};
var $a0b9c834fca6fde8$var$url = window.location.href;
cleanUrl = $a0b9c834fca6fde8$var$url.split(".html")[0];
window.history.replaceState(null, null, cleanUrl);


//# sourceMappingURL=index.70e836a8.js.map
